import React, { useState } from "react";
import "./CurrentHighlightsNew.css";
import Modal from "react-modal";
import data from "./CurrentHighlightsTableData.json";
import UploadIndustryLearningData from "./AdminPages/UploadIndustryLearningData";

function CurrentHighlightsNew() {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [isOpen2, setIsOpen2] = useState(false);
  const openModal2 = () => setIsOpen2(true);
  const closeModal2 = () => setIsOpen2(false);

  const handleClick = () => {
    window.open(
      "https://app.powerbi.com/groups/me/reports/6d5189f9-6d42-4a72-960f-3e7ee0d419e7/a798138868bc34165065?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi"
    ); // Replace with your URL
  };

  return (
    <>
      <div className="current-highlights-wrap">
        <div className="current-highlights-row row1">
          <div className="current-highlights-box">
            <div className="current-content-box">
              <img
                src="images/Home/current-top-bg.png"
                alt="current"
                className="current-top-bg"
              />
              <img
                src="images/Home/current-highlight-icons1.png"
                alt="icon"
                className="current-highlight-icons"
              />
              <h3>Industry Learning</h3>
              <p>
                Industry trainings are designed to deepen employees
                understanding of the industries in which Accenture operates. It
                also helps learning about best practices and standards relevant
                to the industry. This involves industry training options such as
                Foundation Training, Focused Trainings, Industry Day, and
                Reinvention Academy
              </p>
            </div>
            <div className="center">
              <button onClick={openModal} className="btn-primary">
                Learning progress
              </button>
            </div>
          </div>
          <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            className="modal-content"
            overlayClassName="modal-overlay"
            ariaHideApp={false} // Disable for non-portal usage, can be configured for accessibility
          >
            {/* <img
              src="images/Home/industry-traning-data-updated-june.png"
              alt="industry"
              className="industry-traning-data"
            /> */}
            <UploadIndustryLearningData/>
            <button className="close-btn" onClick={closeModal}>
              Close
            </button>
          </Modal>
        </div>
        <div className="current-highlights-row row2">
          <div className="current-highlights-box">
            <div className="current-content-box">
              <img
                src="images/Home/current-top-bg.png"
                alt="current"
                className="current-top-bg"
              />
              <img
                src="images/Home/current-highlight-icons2.png"
                alt="icon"
                className="current-highlight-icons"
              />
              <h3>NVIDIA</h3>
              <p>
                Accenture is pioneering the use of advanced generative AI and
                real-time graphics capabilities with Defender to elevate the
                modern luxury client experience, driving new content production
                practices, conversational intelligence, and interactive
                personalization using NVIDIA’s Omniverse platform and NVIDIA -
                powered models
              </p>
            </div>
            <div class="center">
              <button onClick={handleClick} className="btn-primary">
                Learning progress
              </button>
            </div>
          </div>
        </div>
        <div className="current-highlights-row row3">
          <div className="current-highlights-box">
            <div className="current-content-box">
              <img
                src="images/Home/current-top-bg.png"
                alt="current"
                className="current-top-bg"
              />
              <img
                src="images/Home/current-highlight-icons3.png"
                alt="icon"
                className="current-highlight-icons"
              />
              <h3>Gen AI in TDLC</h3>
              <p>
                Accenture provides client industry leading services across
                Technology Delivery Lifecycle (TDLC) by infusing Generative AI
                with our existing assets and tools in myWizard, myConcerto and
                myNav, resulting in radical improvements in speed efficiency ,
                productivity and Quality . The Gen AI in TDLC* training is a
                core enabler to integrate Gen AI into technology delivery
                projects, enhancing productivity and creating new Gen AI ways of
                working.
              </p>
              <div class="center">
                <button onClick={openModal2} className="btn-primary">
                  Learning progress
                </button>
              </div>
            </div>
          </div>
          <Modal
            isOpen={isOpen2}
            onRequestClose={closeModal2}
            contentLabel="Example Modal"
            className="modal-content second-modal"
            overlayClassName="modal-overlay"
            ariaHideApp={false} 
          >
            <div className="modal-table-box">
              <h2>Generative AI in TDLC</h2>
              <p>
                Generative AI is rapidly evolving and is redefining the “ways of
                delivery” to improve productivity and reduce costs. It has
                become a key differentiator in driving competitive advantage.
                This will now lead to exponential increase of new
                opportunities/contracts with Gen AI embedded productivity.
                Hence, it is important for us to develop an understanding of Gen
                AI Accenture assets, ecosystem tools, use cases, and delivery
                execution playbook.
              </p>
              <p>
                We have three training options based on your career level and
                client delivery role. Every course has 2 levels i.e., Level 1
                and Level 2.
              </p>
              <table>
                <tr>
                  <th></th>
                  <th>Gen AI for Delivery Practitioners (CL 12 & above)</th>
                  <th>Gen AI for Automation Architects (CL 9 & above)</th>
                  <th>
                    Gen AI for Delivery Leads/ Tech Service Leads (CL 7 & above)
                  </th>
                </tr>
                <tr>
                  <td>Level 1 links</td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/learning/program/d67b735c2ae81002f8dff24237510000?type=2d29754fdb8e100008b50ff6bc94003b"
                      target="blank"
                    >
                      Delivery Practitioners Level 1 (CL 12 and above)
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/learning/program/4f612f60a18e1000d2b717dcffc90000?type=2d29754fdb8e100008b50ff6bc94003b"
                      target="blank"
                    >
                      Automation Architects Level 1 (CL 9 & above)
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/23455$846/rel-task/2998$35805.htmld"
                      target="blank"
                    >
                      Delivery Leads Level 1 (CL 7 & above){" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    Level 2 ATCI (Advanced Technology Centres in India) links
                  </td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/17816$15741/rel-task/2998$29489.htmld"
                      target="blank"
                    >
                      Delivery Practitioners Level 2 (CL12 & above){" "}
                    </a>
                  </td>
                  <td>
                    <span>Level 2A - </span>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/17816$15741/rel-task/2998$29489.htmld"
                      target="blank"
                    >
                      Automation Architect Level 2A{" "}
                    </a>
                    <span>Level 2B - </span>
                    <a
                      href="https://wd103.myworkday.com/accenture/learning/course/fcb1482cf529100792b02f4abe800000?type=9882927d138b100019b6a2df1a46018b"
                      target="blank"
                    >
                      Automation Architects (CL 9 & above)
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/17815$5367/rel-task/2997$10951.htmld"
                      target="blank"
                    >
                      Delivery Leads Level 2 (CL 7 & above){" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Level 2 Non-ATCI links</td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/17816$15741/rel-task/2998$29489.htmld"
                      target="blank"
                    >
                      Delivery Practitioners Level 2 (CL12 & above){" "}
                    </a>
                  </td>
                  <td>
                    <span>Level 2A - </span>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/17816$15741/rel-task/2998$29489.htmld"
                      target="blank"
                    >
                      Automation Architect Level 2A{" "}
                    </a>
                  </td>
                  <td>
                    <a
                      href="https://wd103.myworkday.com/accenture/email-universal/inst/17815$5367/rel-task/2997$10951.htmld"
                      target="blank"
                    >
                      Delivery Leads Level 2 (CL 7 & above){" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>
                    <span>Level 2B – </span>
                    <a
                      href="https://wd103.myworkday.com/accenture/d/inst/1$17815/17815$4521.htmld#TABTASKID=2998%2440031"
                      target="blank"
                    >
                      Automation Architects (CL 9 & above) – Non ATCI
                    </a>
                    <span> (except ATCP & Japan) </span>
                    <a
                      href="https://wd103.myworkday.com/accenture/d/inst/1$17815/17815$4264.htmld#TABTASKID=2998%2440031"
                      target="blank"
                    >
                      Automation Architects (CL 9 & above) -Non ATCI Local
                    </a>
                    <span> (for ATCP & Japan) </span>
                  </td>
                  <td></td>
                </tr>
              </table>
              <h3>
                Access our Microsite for more information:{" "}
                <a
                  href="https://atci.lkm.delivery.accenture.com/TT/Automation/genAI"
                  target="blank"
                >
                  TT Automation
                </a>
              </h3>
              <h3>
                Find below the number of people trained and enrolled under each
                programs.
              </h3>

              {/* <div className="table-container">
                <table className="atcs-table">
                  <thead>
                    <tr>
                      <th colSpan="4">ATCs</th>
                    </tr>
                    <tr>
                      <th>Row Labels</th>
                      <th>Completed</th>
                      <th>Registered</th>
                      <th>Grand Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((section, idx) => (
                      <React.Fragment key={idx}>
                        <tr className="section-header">
                          <td colSpan="4">{section.title}</td>
                        </tr>
                        {section.rows
                          .filter((row) => row.label !== "Total")
                          .map((row, subIdx) => (
                            <tr key={subIdx} className="sub-row">
                              <td className="sub-label">{row.label}</td>
                              <td>
                                {row.completed !== "" ? row.completed : "-"}
                              </td>
                              <td>
                                {row.registered !== "" ? row.registered : "-"}
                              </td>
                              <td>{row.total}</td>
                            </tr>
                          ))}
                        {section.rows
                          .filter((row) => row.label === "Total")
                          .map((row, totalIdx) => (
                            <tr key={`total-${totalIdx}`} className="main-row">
                              <td className="main-label">Total</td>
                              <td>{row.completed}</td>
                              <td>
                                {row.registered !== "" ? row.registered : "-"}
                              </td>
                              <td>{row.total}</td>
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}
                    <tr className="last-row">
                      <td>Grand Total</td>
                      <td>93518</td>
                      <td>26269</td>
                      <td>119787</td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
              <div className="dashboardHyperlinksec">
                <a
                  href="https://app.powerbi.com/reportEmbed?reportId=40fd3096-0e36-41d0-8211-0e14381c9b7c&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
                  target="blank"
                >
                  Click Here
                </a>
              </div>
            </div>
            <button className="close-btn" onClick={closeModal2}>
              Close
            </button>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default CurrentHighlightsNew;
